import React, { FC, memo, useCallback } from 'react';

import usePrefix from 'utils/usePrefix';

import { TITLE_CHARS_LIMIT } from '../constants';
import {
  CharCountStyled,
  FormInputBoxStyled,
  FormItemStyled,
  InputStyled,
  LabelStyled,
  FormMessageBoxStyled,
  FormMessageStyled,
  FormMessageGroupStyled,
} from 'components/ResqlExpert/formItemStyles';


interface Props {
  label: string;
  placeholder?: string;
  id: string;
  isRequired?: boolean;
  value: string;
  onChange: (value: string) => void;
  limit?: number;
}

const FormItemTitle: FC<Props> = ({ id, isRequired, label, placeholder, value, onChange, limit = TITLE_CHARS_LIMIT }) => {
  const t = usePrefix('ResqlExpert');

  const handleChange = useCallback((val: string) => {
    onChange(val.slice(0, limit));
  }, [onChange, limit]);

  return (
    <FormItemStyled>
      <FormInputBoxStyled>
        <LabelStyled htmlFor={id}>{label}</LabelStyled>
        <InputStyled
          id={id}
          type="text"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
          placeholder={placeholder}
          maxLength={limit}
        />
        <FormMessageBoxStyled>
          {isRequired ? <FormMessageStyled>{t('field_required')}</FormMessageStyled> : null}
          <FormMessageGroupStyled>
            {value.length >= limit ? (
              <FormMessageStyled aria-live="polite">{t('chars_limit_exceeded')}</FormMessageStyled>
            ) : null}
            <CharCountStyled $isLimit={value.length >= limit} aria-live="polite">
              {`${value.length}/${limit}`}
            </CharCountStyled>
          </FormMessageGroupStyled>
        </FormMessageBoxStyled>
      </FormInputBoxStyled>
    </FormItemStyled>
  );
};

export default memo(FormItemTitle);
